import React, { useState, useRef, useEffect } from 'react';
import './jobSearchBar.css';

const positions = [
  "Garzón", "Runner", "Chef", "Ayudante de Cocina", "Anfitrión", "Delivery", "Cajero", "Copero",
  "Barista", "Bartender", "Sommelier", "Maitre", "Jefe de salón", "Limpieza", "Chef Ejecutivo",
  "Sous Chef", "Jefe de Cocina", "Maestro de Cocina", "Maestro Pastelero", "Pastelero", "Panadero",
  "Repostero", "Charcutero", "Pizzero", "Itamae", "Sushiman", "Ayudante de Sushi", "Parrillero",
  "Cocinero Frío", "Cocinero Caliente", "Manipulador de Alimentos", "Encargado de Producción",
  "Operador de Cocina", "Operador de Planta", "Operador Multifuncional", "Encargado de Reservas",
  "Recepcionista de Restaurante", "Supervisor de Salón", "Personal de Banquetería", "Encargado de Bodega",
  "Repositor", "Personal de Mantenimiento", "Jefe de Local", "Administrador de Local", "Jefe de Sucursales",
  "Administrador de Restaurante", "Encargado de Compras", "Control de Calidad", "Catador de Vinos",
  "Coordinador de Banquetes", "Montajista", "Mixólogo"
];

const JobSearchBar = ({ 
  onSearch, 
  onSelectResult, 
  initialSearchTerm,
  onClearSearch 
}) => {
  const [isResultsVisible, setIsResultsVisible] = useState(false);
  const [localSearchTerm, setLocalSearchTerm] = useState('');
  const [filteredPositions, setFilteredPositions] = useState([]);
  const searchContainerRef = useRef(null);
  const resultsRef = useRef(null);
  const inputRef = useRef(null);

  const handleInputChange = (event) => {
    const value = event.target.value;
    setLocalSearchTerm(value);

    const filtered = positions.filter(position => 
      position.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredPositions(filtered);
    setIsResultsVisible(!!value);
  };

  const handleResultClick = (position) => {
    setLocalSearchTerm(position);
    onSelectResult(position);

    setTimeout(() => {
      setIsResultsVisible(false);
    }, 0);
  };
  
  const handleClickOutside = (event) => {
    if ((!inputRef.current || !inputRef.current.contains(event.target)) && 
        (!resultsRef.current || !resultsRef.current.contains(event.target))) {
      setIsResultsVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [localSearchTerm]);

  useEffect(() => {
    if (onClearSearch) {
      setLocalSearchTerm('');
      setIsResultsVisible(false);
    }
  }, [onClearSearch]);

  return (
    <div className="job-search-bar__container" ref={searchContainerRef}>
      <div className="job-search-bar__title-form-container">
        <h1>La receta perfecta para tu próximo trabajo</h1>
        <div className="job-search-bar__form-container">
          <input
            type="text"
            placeholder="Busca trabajos..."
            value={localSearchTerm}
            onChange={handleInputChange}
            className="job-search-bar__input"
            onFocus={() => setIsResultsVisible(!!localSearchTerm)}
            ref={inputRef}
          />
          {isResultsVisible && filteredPositions.length > 0 && (
            <ul className="job-search-bar__results" ref={resultsRef}>
              {filteredPositions.map((position, index) => (
                <li key={index} onClick={() => handleResultClick(position)}>
                  <h3>{position}</h3>
                </li>
              ))}
            </ul>
          )}
          {isResultsVisible && filteredPositions.length === 0 && (
            <p>No results found</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default JobSearchBar;
